import React from "react";
import { HStack, Button, Text, Icon } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { FiChevronsLeft, FiChevronLeft, FiChevronRight, FiChevronsRight } from "react-icons/fi";

export default function Pagination({ path = "", num_of_items = 0, num_of_pages = 1, currentPage = 1, onPageChange }) {
  // Hooks must be called unconditionally
  const navigate = useNavigate();
  if (!num_of_pages || num_of_pages <= 1) return null;
  const cur = Number(currentPage) || 1;
  const total = Number(num_of_pages) || 1;
  const change = (p) => {
    if (typeof onPageChange === "function") onPageChange(p);
    else {
      let base = path.startsWith("/") ? path : `/${path}`;
      if (!base.endsWith("/")) base = `${base}/`;
      const url = `${base}?page=${p}`;
      navigate(url);
    }
  };
  const makePages = () => {
    if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1);
    if (cur <= 4) return [1, 2, 3, 4, 5, "...", total];
    if (cur >= total - 3) return [1, "...", total - 4, total - 3, total - 2, total - 1, total];
    return [1, "...", cur - 1, cur, cur + 1, "...", total];
  };
  const pages = makePages();
  return (
    <HStack spacing={2}>
      <Text fontSize="sm">Toplam: {num_of_items}</Text>
      <Button size="xs" variant="outline" isDisabled={cur <= 1} onClick={() => change(1)} aria-label="İlk Sayfa">
        <Icon as={FiChevronsLeft} />
      </Button>
      <Button size="xs" variant="outline" isDisabled={cur <= 1} onClick={() => change(cur - 1)} aria-label="Önceki Sayfa">
        <Icon as={FiChevronLeft} />
      </Button>
      {pages.map((p, idx) =>
        p === "..." ? (
          <Button key={`sep-${idx}`} size="xs" variant="ghost" isDisabled>
            ...
          </Button>
        ) : (
          <Button key={p} size="xs" variant={p === cur ? "solid" : "outline"} colorScheme="blue" onClick={() => change(p)}>
            {p}
          </Button>
        )
      )}
      <Button size="xs" variant="outline" isDisabled={cur >= total} onClick={() => change(cur + 1)} aria-label="Sonraki Sayfa">
        <Icon as={FiChevronRight} />
      </Button>
      <Button size="xs" variant="outline" isDisabled={cur >= total} onClick={() => change(total)} aria-label="Son Sayfa">
        <Icon as={FiChevronsRight} />
      </Button>
    </HStack>
  );
}
